const getDevicePixelRatio = () => {
  return (globalThis == null ? void 0 : globalThis.devicePixelRatio) ?? 2;
};
export {
  getDevicePixelRatio
};
//# sourceMappingURL=getDevicePixelRatio.js.map
